import { render, staticRenderFns } from "./enumDescriptions.vue?vue&type=template&id=2b4c39c4&"
import script from "./enumDescriptions.vue?vue&type=script&lang=js&"
export * from "./enumDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./enumDescriptions.vue?vue&type=style&index=0&id=2b4c39c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports